import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseForUser } from 'app/_models/training/training-course-for-user.model';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'contractor-dashboard',
  templateUrl: './contractor-dashboard.component.html'
})
export class ContractorDashboardComponent implements OnInit {

  public routeRole: string;
  private selectedContractorId: any;
  public totalWorkers: number;
  public siteOperators = [];
  public certificates = [];
  public needsCerts: boolean;
  public contractorCourseNeedsAttentionCount: number;
  public hasPowerStationOwnerRelation: any;

  constructor(
    private contractorService: ContractorService,
    private trainingService: TrainingService,
    private router: Router,
    private notificationService: NotificationService,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;

    this.hasPowerStationOwnerRelation = globals.contractor.hasPowerstationRelation
  }

  ngOnInit() {
    this.getCompanyDetails();
  }

  public getCompanyDetails() {
    this.trainingService.getOutageAcceptanceListForCurrentContractorManager().subscribe(trainingCourses => {
      this.contractorCourseNeedsAttentionCount = trainingCourses.filter(course => course.courseProgress === TrainingCourseState.NotStarted || course.courseProgress === TrainingCourseState.InProgress).length;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load outage acceptance data');
    });

    this.contractorService.getContractorForCurrentUser().subscribe((data: any) => {
      this.selectedContractorId = data.id;

      this.certificates = [];
      data.maintenanceSiteOwners.forEach(mso => {
        this.needsCerts = this.needsCerts || mso.status === 'PENDING_UPLOAD' || mso.status === 'PENDING_APPROVAL' || mso.status === 'PENDING_RENEWAL';
        let mappedCerts = mso.maintenanceSiteOwnerCompetencyTypes.map(cert => {
          cert.siteOwnerName = mso.siteOwnerUser.name;
          return cert;
        });
        this.certificates.push(...mappedCerts);
        this.certificates = this.certificates
            .filter(c => !c.deleted)
            .map(c => this.mapNearExpiry(c))
            .filter(c => c.nearExpiry || c.status !== 'APPROVED')
            .sort(this.sortByExpiryDate);
      });

      this.contractorService.getAllWorkersForContractor(this.selectedContractorId, { size: 1, page: 0 }, '').subscribe((data: any) => {
        this.totalWorkers = data.totalRecords;
      });
    });
  }

  public goToWorkers() {
      this.router.navigate([this.routeRole, 'workers']);
  }

  public goToOutages() {
    this.router.navigate([this.routeRole, 'outage-acceptance']);
  }

  private mapNearExpiry(cert: any): any {
    if(cert.expiryDate){
      let weekLater = new Date();
      weekLater.setDate(weekLater.getDate() + 7);
      if(new Date(cert.expiryDate) < weekLater && cert.status === "APPROVED"){
        cert.nearExpiry = true;
      }
    }
    return cert;
  }

  private sortByExpiryDate(a, b): number {
    if (!a.expiryDate) { return -1; };
    if (!b.expiryDate) { return 1; };

    return a.expiryDate.localeCompare(b.expiryDate);
  }
}
